// eslint-disable-next-line no-shadow
export enum ScreenSize {
  SM = 320,
  MD = 740,
  PARALLAX = 1024,
  LG = 1240,
}

export const breakpoints = {
  smallOnly: `(max-width: ${ScreenSize.MD / 16}em)`,
  extraSmall: `(max-width: ${ScreenSize.SM / 16}em)`,
  small: `(min-width: ${(ScreenSize.SM + 1) / 16}em)`,
  medium: `(min-width: ${(ScreenSize.MD + 1) / 16}em)`,
  large: `(min-width: ${(ScreenSize.LG + 1) / 16}em)`,
  ltLarge: `(max-width: ${ScreenSize.LG / 16}em)`,

  // Breakpoints for parallax elements
  parallaxOn: `(min-width: ${(ScreenSize.PARALLAX + 1) / 16}rem)`,
  parallaxOff: `(max-width: ${ScreenSize.PARALLAX / 16}rem)`,
}

export const mq = Object.keys(breakpoints).reduce(
  (obj, bp) => ({
    ...obj,
    [bp]: `@media ${breakpoints[bp as keyof typeof breakpoints]}`,
  }),
  {} as typeof breakpoints
)
